import EditMetaDataItem from './EditMetaDataItem-redux';

export default EditMetaDataItem;
